<template>
    <!-- Hero Section -->
    <div v-if="brandComplex" class="text-center rounded-heder-brand-complexes" 
    :style="{ 'background': 'linear-gradient(' + brandComplex.primaryColourHexCode + ',' + brandComplex.secondaryColourHexCode + ')' }"> 
      <div class="mb-5 header-bg-brand-complexes p-2 p-md-5" :style="{'background-image': 'url(' + brandComplex.background?.svg + ')' }">
      <div class="container">
        <div class="row mobile-padding-header-brand">
          <!-- Left column -->
          <div class="col-lg-6 col-12 text-white align-content-center">
            <div v-if="brandComplex.logo?.svg" class="d-flex align-items-center">
              <!-- Logo -->
              <img :src="brandComplex.logo?.svg" alt="Logo 1" class="img-fluid logo-img">
            </div>
            <!-- Title -->
            <h2 v-if="brandComplex.slogan" class="title-header-brand-complex text-break text-left mt-3 pl-1 font-weight-800">{{ brandComplex.slogan }}</h2>
            <!-- Description -->
            <p  v-if="brandComplex.engagement" class="text-break text-left mb-5 pl-1 sub-header-brand-complex">{{ brandComplex.engagement }}</p>
            <!-- <button class="btn d-flex ml-1 button-headers-brand-complex" :style="{'background-color':  brandComplex.primaryColourHexCode }">Discover More</button> -->
            <div class="button-container">
              <button @click="scrollToContent" class="btn d-flex ml-1 button-headers-brand-complex" :style="{'background-color':  brandComplex.primaryColourHexCode }">
                {{ $t('BrandComplex.discoverMore') }}
              </button>
            </div>
          </div>
  
          <!-- Right column -->
          <div class="col-lg-6 col-12 d-flex justify-content-center align-items-center">
            <!-- Image -->
            <img :src="brandHeaderImage" class="img-fluid img-big mb-5" alt="Your Image">
          </div>
        </div>
      </div>
    </div>
    </div>
    <!-- Display POC carousel  -->
</template>

<script>


export default {
  name: "brandHeader",
  props: { 
    settingsPerm: Object,
    brandInputData: Object
  },
  data() {
    return {
        brandComplex: false,
        brandComplexId: false,
        brandSlug: false,
        brandsWidget: false,
        brandHeaderImage: 'https://image-placeholder.com/images/actual-size/300x250.png',
        isDevMioActive: false,
        }
  },


  created() {
    if (this.settingsPerm && this.settingsPerm.isDevMioActive) {
        this.isDevMioActive = this.settingsPerm.isDevMioActive;
    }
    if (this.brandInputData && this.brandInputData.brandComplex && this.brandInputData.brandComplex.BrandComplex) {
      this.brandComplex = this.brandInputData.brandComplex.BrandComplex;
    }
    if (this.settingsPerm && this.settingsPerm.brandComplexId) {
      this.brandComplexId = this.settingsPerm.brandComplexId;
    }
    if (this.settingsPerm && this.settingsPerm.brandSlug) {
      this.brandSlug = this.settingsPerm.brandSlug;
    }
    if(this.settingsPerm && this.settingsPerm.brandsWidgetsData && this.settingsPerm.brandsWidgetsData.brand_header_image){
      this.brandHeaderImage = this.settingsPerm.brandsWidgetsData.brand_header_image
    }
  },
  
  methods: {

      scrollToContent() {
      const contentSection = document.getElementById('content-section');
      if (contentSection) {
        contentSection.scrollIntoView({ behavior: 'smooth' });
      }
    }
    },

};
</script>
  
<style scoped>

  .logo-img {
    max-width: 270px; 
    height: 130px;
  }

  .font-weight-800 {
    font-weight: 800;
  } 

  @media (min-width: 1200px) {
    .img-big {
      min-height: 400px;
      /* object-fit: contain; */
    }
  }

  .rounded-heder-brand-complexes {
    border-radius: 40px;
  }

  .header-bg-brand-complexes {
    background-repeat: no-repeat;
    background-position: center;
  }

  .title-header-brand-complex {
    font-size: clamp(28px, 3vw, 48px);
    font-family: 'Open Sans';
    margin-bottom: clamp(38px, 2vw, 58px);
  }
  .sub-header-brand-complex {
    font-size: clamp(18px, 3vw, 28px);
    font-family: Arial, Helvetica, sans-serif;
  }

  .button-headers-brand-complex {
    font-family: Arial, Helvetica, sans-serif;
    border-radius: 10px;
    font-size: 20px;
    padding: 19px 40px;
    color: white;
  }

  .button-container {
    display: none; /* hide by default */
  }

  /* Show button container from tablet size onwards */
  @media (min-width: 991px) {
    .button-container {
      display: block;
    }
  }
  @media (max-width: 768px) {
    .logo-img {
      max-width: 100%; 
      max-height: 100px; 
      height: 100px;
      width: auto;
   }
   .mobile-padding-header-brand{
    padding: 1rem;
   }
  }

</style>
  